import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo, Button } from "./kit";
import { useAuth } from "../context/AuthContext";

export default function SiteNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Home", to: "/" },
    { label: "Solutions", to: "/solutions" },
    { label: "Pricing", to: "/pricing" },
  ];

  const getStarted = () => {
    if (user) navigate(user.role === "coach" ? "/coach" : "/onboarding");
    else navigate("/register");
  };

  const homeFor = (u) => (u?.role === "coach" ? "/coach" : "/dashboard");

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 40,
        background: "rgba(248,249,248,0.86)",
        backdropFilter: "blur(10px)",
        borderBottom: "1px solid var(--border-hairline)",
      }}
    >
      <div
        className="buktu-wrap"
        style={{ display: "flex", alignItems: "center", gap: "var(--space-6)", paddingTop: "var(--space-4)", paddingBottom: "var(--space-4)" }}
      >
        <Logo height={28} testId="nav-logo" />

        <nav className="buktu-desktop-nav" style={{ display: "flex", gap: "var(--space-6)", marginLeft: "var(--space-4)" }}>
          {links.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase()}`}
                style={{
                  border: 0,
                  borderBottom: 0,
                  font: "var(--type-label)",
                  color: active ? "var(--buktu-green-deep)" : "var(--text-muted)",
                  fontWeight: active ? 600 : 500,
                }}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="buktu-desktop-nav" style={{ marginLeft: "auto", display: "flex", gap: "var(--space-3)", alignItems: "center" }}>
          {user ? (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-dashboard-btn" onClick={() => navigate(homeFor(user))}>
                Dashboard
              </Button>
              <Button variant="secondary" size="sm" data-testid="nav-logout-btn" onClick={doLogout}>
                Log out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-login-btn" onClick={() => navigate("/login")}>
                Login
              </Button>
              <Button size="sm" data-testid="nav-get-started-btn" onClick={getStarted}>
                Get Started
              </Button>
            </>
          )}
        </div>

        <button
          className="buktu-mobile-toggle"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          style={{ marginLeft: "auto", display: "none", border: 0, background: "transparent", cursor: "pointer", color: "var(--text-strong)" }}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="buktu-mobile-menu" style={{ borderTop: "1px solid var(--border-hairline)", background: "var(--surface-card)", padding: "var(--space-4) var(--page-gutter)", display: "flex", flexDirection: "column", gap: "var(--space-3)" }}>
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} data-testid={`nav-mobile-${l.label.toLowerCase()}`} style={{ borderBottom: 0, font: "var(--type-label)", color: "var(--text-body)", padding: "var(--space-2) 0" }}>
              {l.label}
            </Link>
          ))}
          <div style={{ display: "flex", gap: "var(--space-3)", marginTop: "var(--space-2)" }}>
            {user ? (
              <>
                <Button variant="secondary" size="sm" full onClick={() => { setOpen(false); navigate(homeFor(user)); }}>Dashboard</Button>
                <Button variant="ghost" size="sm" full onClick={() => { setOpen(false); doLogout(); }}>Log out</Button>
              </>
            ) : (
              <>
                <Button variant="secondary" size="sm" full onClick={() => { setOpen(false); navigate("/login"); }}>Login</Button>
                <Button size="sm" full onClick={() => { setOpen(false); getStarted(); }}>Get Started</Button>
              </>
            )}
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 860px) {
          .buktu-desktop-nav { display: none !important; }
          .buktu-mobile-toggle { display: inline-flex !important; }
        }
        @media (min-width: 861px) {
          .buktu-mobile-menu { display: none !important; }
        }
      `}</style>
    </header>
  );
}
